import $http from "../../axios";
import {
    Notification,
    MessageBox
} from 'element-ui';



//Obtener los terceros
export async function fetchContacts({
    commit,
    state
}, requestParameters = {
    params: state.params_cotact
}) {
    await $http.get('/api/terceros', requestParameters)
        .then((response) => {
            commit('setContacts', response.data.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
            commit('contactError', error.message)
        })
}

// obtener Data libro Contable
export async function fetchReportCommisions({commit, state}) {
    //console.log(state.params);
    await $http.get('/api/reporte-comisiones', { params : state.params})
        .then((response) => {
            //console.log(response.data.data);
            commit('setreporte_comisiones', response.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

// obtener Data libro Contable
export async function fetchReportCommisionsPm({commit, state}) {
    //console.log(state.params);
    await $http.get('/api/reporte-comisiones-pm', { params : state.params})
        .then((response) => {
            //console.log(response.data.data);
            commit('setreporte_comisiones', response.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

// obtener Data libro Contable
export async function fetchReportCommisionsDisccounts({commit, state}) {
    //console.log(state.params);
    await $http.get('/api/reporte-comisiones-descuentos', { params : state.params})
        .then((response) => {
            //console.log(response.data.data);
            commit('setreporte_comisiones_descuento', response.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

// obtener Data libro Contable
export async function fetchReportCommisionsPays({commit, state}) {
    //console.log(state.params);
    await $http.get('/api/reporte-comisiones-pagos', { params : state.params})
        .then((response) => {
            //console.log(response.data.data);
            commit('setreporte_comisiones_pagos', response.data);
            state.loading.module = false;
        })
        .catch((error) => {
            Notification.error({
            title: 'Error!',
            message: 'Error',
            type: 'error',
            duration: 2000,
            customClass: 'notification-box',
        });
    })
}

export async function fetchLines ({ dispatch, state, rootState, commit }) {
    if (!state.lines.length) {
        await dispatch('lines/fetchLines', { params: { paginate: false } }, { root: true })
        commit('setLines', rootState.lines.lines)
    }
}

export async function downloadAccountingPdf({}, data) {
    let name = data.name_cont + ' No. ' + data.cash_receipt + '.pdf'
    await $http({
        url: '/api/descargar-pdf-contabilidad/'+data.document_id
        ,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
}
export async function downloadDocumentPdf({state}, data) {
    let name = data.name_inv + ' No. ' + data.invoice + '.pdf'
    let url =  '/api/documentos/descargar-pdf/' + data.affects_document_id

    await $http({
        url: url,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
    state.loading.download_pdf = false
}

export function fetchPaymentMethodsCredit({ commit, state }) {
    return new Promise((resolve, reject) => {
        $http.get('/api/payment-methods', {
            params: {
                perPage: 100,
                page: 1,
                pagination: false,
                code_dian: '02'
            }
        })
        .then((response) => {
            resolve(response.data);
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: 'Error formas de pago.',
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });

            reject(error);
        });
    });
}


// WEBPACK FOOTER //
// ./src/modules/report-commisions/actions.js